import { Box, Skeleton } from "@mui/material";

export const GameDetailsSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="80%" height={32} sx={{ mb: 2 }} />
    <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
    <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3 }} />

    <Skeleton
      variant="rectangular"
      width="100%"
      height={200}
      sx={{ mb: 3, borderRadius: 2 }}
    />

    <Skeleton variant="text" width="50%" height={24} sx={{ mb: 2 }} />
    <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="circular" width={40} height={40} />
    </Box>

    <Skeleton
      variant="rectangular"
      width="100%"
      height={50}
      sx={{ borderRadius: 1 }}
    />
  </Box>
);

export const GameCardSkeleton = () => (
  <Box sx={{ p: 2, border: "1px solid #E5E5E5", borderRadius: 2, mb: 2 }}>
    <Skeleton variant="text" width="70%" height={24} sx={{ mb: 1 }} />
    <Skeleton variant="text" width="50%" height={16} sx={{ mb: 1 }} />
    <Skeleton variant="text" width="30%" height={16} sx={{ mb: 2 }} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={40}
      sx={{ borderRadius: 1 }}
    />
  </Box>
);

export const DashboardSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="40%" height={36} sx={{ mb: 3 }} />

    <GameCardSkeleton />
    <GameCardSkeleton />

    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
      <Skeleton
        variant="rectangular"
        width="50%"
        height={100}
        sx={{ borderRadius: 2 }}
      />
      <Skeleton
        variant="rectangular"
        width="50%"
        height={100}
        sx={{ borderRadius: 2 }}
      />
    </Box>
  </Box>
);

export const ProfileSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
      <Skeleton variant="circular" width={80} height={80} sx={{ mr: 2 }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" height={24} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="40%" height={16} />
      </Box>
    </Box>

    <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={40}
      sx={{ mb: 2, borderRadius: 1 }}
    />

    <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={40}
      sx={{ mb: 2, borderRadius: 1 }}
    />

    <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={100}
      sx={{ borderRadius: 1 }}
    />
  </Box>
);

export const PlayerListSkeleton = () => (
  <Box>
    {[1, 2, 3, 4].map((item) => (
      <Box
        key={item}
        sx={{ display: "flex", alignItems: "center", py: 1, gap: 2 }}
      >
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="text" width="40%" height={16} />
        <Box sx={{ ml: "auto" }}>
          <Skeleton
            variant="rectangular"
            width={60}
            height={20}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>
    ))}
  </Box>
);

export const SettingsSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="40%" height={32} sx={{ mb: 3 }} />

    {[1, 2, 3, 4].map((item) => (
      <Box key={item} sx={{ mb: 3 }}>
        <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={48}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    ))}

    <Skeleton
      variant="rectangular"
      width="100%"
      height={48}
      sx={{ borderRadius: 1, mt: 4 }}
    />
  </Box>
);

export const PaymentsSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="50%" height={32} sx={{ mb: 3 }} />

    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={80}
        sx={{ borderRadius: 2 }}
      />
    </Box>

    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
      {[1, 2, 3].map((item) => (
        <Box
          key={item}
          sx={{
            display: "flex",
            alignItems: "center",
            py: 2,
            borderBottom: "1px solid #E5E5E5",
          }}
        >
          <Skeleton variant="circular" width={24} height={24} sx={{ mr: 2 }} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={16} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="40%" height={14} />
          </Box>
          <Skeleton variant="text" width="20%" height={16} />
        </Box>
      ))}
    </Box>
  </Box>
);

export const GameListSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="40%" height={32} sx={{ mb: 3 }} />

    {[1, 2, 3].map((item) => (
      <GameCardSkeleton key={item} />
    ))}
  </Box>
);

export const GroupSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
      <Skeleton variant="circular" width={60} height={60} sx={{ mr: 2 }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="50%" height={16} />
      </Box>
    </Box>

    <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
    <Skeleton
      variant="rectangular"
      width="100%"
      height={60}
      sx={{ mb: 3, borderRadius: 1 }}
    />

    <Skeleton variant="text" width="25%" height={20} sx={{ mb: 1 }} />
    <PlayerListSkeleton />
  </Box>
);

export const CreateGameSkeleton = () => (
  <Box sx={{ px: 2, py: 3 }}>
    <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />

    {/* Stepper */}
    <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
      <Skeleton
        variant="rectangular"
        width="50%"
        height={8}
        sx={{ borderRadius: 1 }}
      />
      <Skeleton
        variant="rectangular"
        width="50%"
        height={8}
        sx={{ borderRadius: 1 }}
      />
    </Box>

    {/* Form fields */}
    {[1, 2, 3, 4].map((item) => (
      <Box key={item} sx={{ mb: 3 }}>
        <Skeleton variant="text" width="30%" height={16} sx={{ mb: 1 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={48}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    ))}

    <Skeleton
      variant="rectangular"
      width="100%"
      height={48}
      sx={{ borderRadius: 1, mt: 4 }}
    />
  </Box>
);
